export default "__VITE_ASSET__61662d72__"